import { createContext } from "react";

export const ActiveQuoteShowInternalContext = createContext(false);
